

module.exports = ['$rootScope', '$http', '$q', 'ModalSvc', function ($root, $http, $q, ModalSvc) {
    "use strict";

    var InvitationSvc = {

        list_pending(params) {
            var url = `/pending_invitations/`;
            return $http({
                method: 'GET',
                url: url,
                params: params
            });
        },
        list_plant_pending(plant, params) {
            var url = `/plant/${plant}/pending_invitations/`;
            return $http({
                method: 'GET',
                url: url,
                params: params
            });
        },
        delete(invitation, plant, confirm=true) {

            var deferred = $q.defer();

            if(confirm){
                var confirmation = ModalSvc.confirmationDialog.open({
                    title: `Delete invitation?`,
                    message: `Are you sure you want to delete the invitation for ${invitation.to_user}?`
                });

                confirmation.result.then(function(){
                    doDelete();
                });
            }
            else {
                doDelete();
            }

            function doDelete(){

                var url = `/plant/${plant}/invitation/delete/${invitation.id}`;

                return $http({
                    method: 'DELETE',
                    url: url
                }).then(function(data){
                    deferred.resolve(data);
                });
            }

            return deferred.promise;
        }
    };
    return InvitationSvc;

}];
